import { Stack } from 'expo-router';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';
import { isDesktop } from '@/core';

export default function ProfileLayout() {
  const { theme } = useStyles();

  return (
    <Stack>
      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="index"
          options={{
            title: 'Profile',
            headerTitle: 'Profile',
            headerLeft: () => <BackButton />,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="email/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="email/index"
          options={{
            title: 'Email',
            headerTitle: 'Email',
            headerLeft: () => <BackButton />,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="name/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="name/index"
          options={{
            title: 'Name',
            headerTitle: 'Name',
            headerLeft: () => <BackButton />,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="phone/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="phone/index"
          options={{
            title: 'Phone',
            headerTitle: 'Phone',
            headerLeft: () => <BackButton />,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="password/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="password/index"
          options={{
            title: 'Password',
            headerTitle: 'Password',
            headerLeft: () => <BackButton />,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}
    </Stack>
  );
}
